import {Stop} from './stop.model';

export class Route {

    id: number;
    pick_stop_id: number;
    drop_stop_id: number;
    pick_stop: Stop;
    drop_stop: Stop;
    pick_time: string;
    drop_time: string;
    start_date: string;
    end_date: string;
    adult_price: number;
    child_price: number;
    infant_price: number;
    discount_price: number;
    child_discount_price?: number;
    route_group_id: number;
    created: string;

    constructor(
        id: number, pick_stop_id: number, drop_stop_id: number, pick_time: string, drop_time: string,
        start_date: string, end_date: string, adult_price: number, child_price: number, infant_price: number, route_group_id: number) {
        this.id = id;
        this.pick_stop_id = pick_stop_id;
        this.drop_stop_id = drop_stop_id;
        this.pick_time = pick_time;
        this.drop_time = drop_time;
        this.start_date = start_date;
        this.end_date = end_date;
        this.adult_price = adult_price;
        this.child_price = child_price;
        this.infant_price = infant_price;
        this.route_group_id = route_group_id;
    }
}

export class RouteCreate {

    id: number;
    pick_stop_id: number;
    drop_stop_id: number;
    pick_time: string;
    drop_time: string;
    start_date: string;
    end_date: string;
    adult_price: number;
    child_price: number;
    infant_price: number;
    route_group_id: number;
    created: string;

    constructor(
        pick_stop_id: number, drop_stop_id: number, pick_time: string, drop_time: string,
        start_date: string, end_date: string, adult_price: number, child_price: number, infant_price: number, route_group_id: number) {
        this.pick_stop_id = pick_stop_id;
        this.drop_stop_id = drop_stop_id;
        this.pick_time = pick_time;
        this.drop_time = drop_time;
        this.start_date = start_date;
        this.end_date = end_date;
        this.adult_price = adult_price;
        this.child_price = child_price;
        this.infant_price = infant_price;
        this.route_group_id = route_group_id;
    }
}

